module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    class: (_vm.prefixClassName + "-container"),
    style: (_vm.containerStyle)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-404db2a3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/autoresponsive.vue
// module id = 14
// module chunks = 0 1 2